var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticStyle:{"padding-left":"5px"},attrs:{"id":"documentoParaAssinar"}}),_c('filiacaoLiberada',{ref:"filiacaoModal"}),_c('documentacaoPendente',{ref:"documentacaoModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }